import React, { useEffect, useState } from "react";
import { Card, Button, notification, Spin } from "antd";
import {
  CheckOutlined,
  FireOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import RegisterationCallbackModal from "../../components/RegisterationCallbackModal";
import { useDispatch, useSelector } from "react-redux";
import { __hideLoader, __showLoader } from "../../Redux Store/Slices/loader";
import axios from "axios";
import { courseEnrollmentUrl, courseUrl } from "../../urls";
import useErrorHandler from "../../hooks/useErrorHandler";

const CourseOfferings = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false)
  const handleError = useErrorHandler();

  // const courses = [
  //   {
  //     id: 1,
  //     title: "Frontend Engineering",
  //     duration: "6 MONTHS",
  //     startDate: "Feb 10, 2025",
  //     emi: "Rs. 7,200",
  //     studentsEnrolled: "1,200+ Students already enrolled",
  //     badgeColor: "text-blue-600",
  //     chipColor: "bg-blue-600",
  //     techStack: [
  //       "React.js",
  //       "Tailwind CSS",
  //       "Redux",
  //       "Next.js",
  //       "Ant Design",
  //       "Material-UI",
  //     ],
  //     features: [
  //       "1:1 Mentorship Sessions Daily with industry professionals",
  //       "Get a professional certificate on completion of course",
  //       "Mock interviews for your interview practice",
  //       "Exlusive Workshop & Hackathons",
  //       "Placement Preparation",
  //       "No coding experience required",
  //     ],
  //   },
  //   {
  //     id: 2,
  //     title: "Backend Engineering (Upcoming)",
  //     duration: "6 MONTHS",
  //     startDate: "Coming soon",
  //     emi: "Rs. 6,167",
  //     studentsEnrolled: "6,300+ Students already enrolled",
  //     badgeColor: "text-green-600",
  //     chipColor: "bg-green-600",
  //     techStack: [
  //       "Node.js",
  //       "Express.js",
  //       "Supabase",
  //       "Firebase",
  //       "PostgreSQL",
  //     ],
  //     features: [
  //       "1:1 Mentorship Sessions Daily with industry professionals",
  //       "Get a professional certificate on completion of course",
  //       "Mock interviews for your interview practice",
  //       "Exlusive Workshop & Hackathons",
  //       "Placement Preparation",
  //       "No coding experience required",
  //     ],
  //     disabled: true,
  //   },
  // ];
  const [courses, setCourses] = useState([]);
  // TEMP_CHANGES
  // useEffect(() => {
  //   setLoading(true);
  //   dispatch(__showLoader())
  //   axios.get(courseUrl).then(res => {
  //     setCourses(res.data);
  //   }).catch(err => {
  //     handleError(err)
  //   }).finally(() => {
  //     setLoading(false);
  //     dispatch(__hideLoader())
  //   })
  // }, []);

  return (
    <div id="courses" className="flex flex-col md:flex-row gap-6 p-6 section">
      {loading ? <Spin size="large" />
        :
        courses.map((course, index) => (
          <OfferingCourseCard
            key={index}
            course={course.course || course}
            navigate={navigate}
            isEnrollModal
            type={course.type}
          />
        ))
      }
    </div>
  );
};

export default CourseOfferings;

export const OfferingCourseCard = ({
  course,
  // navigate,
  isEnrollDirect = false,
  seeCertificate = false,
  isEnrollModal = false,
  type,
  className
}) => {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false);
  const [isEnrolled, setIsEnrolled] = useState(course?.isEnrolled || false);
  const dispatch = useDispatch();
  const handleError = useErrorHandler();
  const [api, contextHolder] = notification.useNotification();
  const { user } = useSelector((state) => state.auth);
  const [showMore, setShowMore] = useState(false)
  console.log(user);
  console.log(99, course);

  useEffect(() => {
    const windowHash = window.location.hash
    const courseHashName = `#${(course?.name)?.replaceAll?.(" ", "%20")}`;
    console.log({ windowHash, courseHashName })
    if (
      window.location.hash ===
      `#${(course?.title || course?.name)?.replaceAll?.(" ", "%20")}`
    ) {
      console.log(889)
      setTimeout(() => {
        console.log(888)
        setOpen(true)
      }, 0);
    }
    console.log(9999)
  }, [course?.title]);

  function enrollDirect() {
    const payload = {
      userId: user.username,
      courseId: course?.id,
      purchaseDate: new Date().toISOString().split("T")[0], // Current date
      price: 7200, // Static price (can be dynamic if needed)
      expiryDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1))
        .toISOString()
        .split("T")[0], // 1 year from now
      paymentId: "order_PndZTxPehKscy9",
    };

    dispatch(__showLoader("Enrolling..."));
    axios
      .post(courseEnrollmentUrl, payload)
      .then((res) => {
        setTimeout(() => {
          window.location.reload();
        }, 2000);

        // setCourses(res.data);
        api.info({
          message: "Notification",
          description: "Course Enrollment Successful!",
          duration: 0,
        });
        setIsEnrolled(true);
      })
      .catch((err) => {
        handleError(err);
      })
      .finally(() => {
        dispatch(__hideLoader());
      });
  }

  const enrollButton = (course) => (
    <Button
      disabled={course?.disabled || isEnrolled}
      type="primary"
      className={`text-white ${course?.buttonColor} px-4 py-2 rounded-md`}
      icon={<CheckOutlined />}
      onClick={() => {
        if (!isEnrollModal) {
          navigate("/dashboard/courses/" + course.id)
        }
        if (isEnrollDirect && !isEnrolled) {
          // enrollDirect();
        }
      }}
    >
      {isEnrollModal ? "Enroll Now" : "View Course"}
    </Button>
  );

  return (
    <div className={"relative flex-1 md:w-1/2 " + className}>
      <Card
        key={course?.id}
        className="relative w-full rounded-2xl shadow-md border border-gray-200 bg-white md:p-6"
      >
        {/* Course Title & Badges */}
        <h2 className={`text-lg md:text-2xl font-bold`}>{course?.title || course?.name}</h2>
        <div className="flex gap-2 mt-2">
          <span
            className={`px-3 py-1 text-xs font-semibold rounded-md bg-green-600 text-white`}
          >
            ONLINE
          </span>
          <span
            className={`px-3 py-1 text-xs font-semibold bg-green-600 text-white rounded-md`}
          >
            {course?.duration} {course?.duration === 1 ? "Month" : "Months"}
          </span>
          <span
            className={`px-3 py-1 text-xs font-semibold bg-blue-600 text-white rounded-md`}
          >
            {type}
          </span>
        </div>

        {/* Course Details Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
          <div className="bg-gray-50 p-4 rounded-lg">
            <p className="text-xs font-semibold text-gray-500">
              NEW BATCH START FROM
            </p>
            <p className="text-lg font-semibold text-gray-800">
              {course.type === 'PAID' ? "10th Feb 2025" : course?.startDate || "---"}
            </p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg">
            <p className="text-xs font-semibold text-gray-500">
              SCHOLARSHIP AVAILABLE
            </p>
            <p className="text-lg font-semibold text-gray-800">Yes</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg">
            <p className="text-xs font-semibold text-gray-500">
              Flexible Payment Options
            </p>
            <p className="text-lg font-semibold text-gray-800">{course.type === "FREE" ? "Free" : "Available"}</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg">
            <p className="text-xs font-semibold text-gray-500">ELIGIBILITY</p>
            <p className="text-lg font-semibold text-gray-800">Open for All</p>
          </div>
        </div>

        {/* Features List */}
        <ul className="mt-6 text-gray-700">
          {(course?.about?.split("--- ").filter(a => !!a) || [])
            .slice(0, showMore ? undefined : 4)
            .map((feature, i) => (
              <li key={i} className="flex items-start gap-2 text-sm mb-2">
                <CheckOutlined className="text-green-500 relative top-1" />
                {feature}
              </li>
            ))}
        </ul>

        <p className="text-blue-500 cursor-pointer underline text-right" onClick={() => setShowMore(!showMore)} >{!showMore ? "Show More" : "Show Less"}</p>
        {/* Buttons */}
        <div className="flex flex-wrap items-center gap-3 mt-6">
          {isEnrollModal ? (
            <RegisterationCallbackModal
              id={course?.id}
              name={course?.name}
              buttonComp={enrollButton(course)}
            />
          ) : (
            enrollButton(course)
          )}

          <RegisterationCallbackModal
            open={open}
            id={course?.id}
            name={course?.name}
          />
          <a
            href="https://pronttera-resource.s3.ap-south-1.amazonaws.com/frontend-curriculum/Detailed+curriculum.pdf"
            target="_blank"
          >
            <Button
              disabled={course?.disabled || type === "FREE"}
              type="primary"
              className={`text-white ${course?.buttonColor} px-4 py-2 rounded-md`}
            >
              Explore Course
            </Button>
          </a>

          <a
            href="https://pronttera-resource.s3.ap-south-1.amazonaws.com/broucher/Circuit+Brochure.pdf"
            target="_blank"
            download={true}
          >
            <Button
              icon={<DownloadOutlined />}
              className="flex items-center gap-1 border px-4 py-2 rounded-md"
            >
              Download Brochure
            </Button>
          </a>
          {seeCertificate && isEnrolled && (
            <Button
              disabled={course?.disabled}
              icon={<DownloadOutlined />}
              className="flex items-center gap-1 border px-4 py-2 rounded-md"
            >
              See Certificate
            </Button>
          )}
        </div>
      </Card>
    </div>
  );
};
